module.exports = __webpack_public_path__ + "img/cloud-city.a53331a7.png";